// Fades and rises each top-level page section into view the first time it
// scrolls into the viewport. The first section is skipped since it's already
// visible on load (avoids hiding above-the-fold / LCP content).
(function () {
  var sections = document.querySelectorAll('#MainContent > .shopify-section');

  if (sections.length < 2) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('scroll-reveal--visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  for (var i = 1; i < sections.length; i++) {
    observer.observe(sections[i]);
  }
})();
